module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "page-loading loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "user card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('figure', {
    staticClass: "media-left"
  }, [_c('p', {
    staticClass: "image",
    staticStyle: {
      "height": "100px",
      "width": "100px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.profile.face_url
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_c('strong', [_vm._v(_vm._s(_vm.profile.id))])]), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, [_c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v(" " + _vm._s(_vm.profile.user_name) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_c('i', {
    staticClass: "iconfont role icon-account",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "role"
  }, [_vm._v(_vm._s(_vm.profile.role))]), _vm._v(" "), (_vm.profile.gender == 'm') ? _c('i', {
    staticClass: "iconfont icon-male",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "iconfont icon-female",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_c('a', {
    staticClass: "button is-outlined is-primary is-small",
    on: {
      "click": function($event) {
        _vm.sendMail()
      }
    }
  }, [_c('i', {
    staticClass: "small iconfont icon-email"
  }), _vm._v("\n                   私信\n                ")]), _vm._v(" "), _c('a', {
    staticClass: "button is-outlined is-info is-small",
    on: {
      "click": function($event) {
        _vm.addFriend()
      }
    }
  }, [_c('i', {
    staticClass: "small iconfont icon-add"
  }), _vm._v("\n                  添加好友\n                ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.profile.life))]), _vm._v(" "), _c('div', [_vm._v("生命力")])]), _vm._v(" "), _c('a', {
    staticClass: "card-footer-item"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.profile.post_count) + " ")]), _vm._v(" "), _c('div', [_vm._v(" 文章 ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-footer-item"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.profile.score) + " ")]), _vm._v(" "), _c('div', [_vm._v(" 积分 ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "pannel-box"
  }, [_c('div', {
    staticClass: "basic-info box"
  }, [_c('span', [_vm._v(" 等级 ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.profile.level) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "basic-info box"
  }, [_c('span', [_vm._v(" 状态 ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.profile.isOnline ? "在线" : "离线") + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "basic-info box"
  }, [_c('span', [_vm._v(" 星座 ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.profile.astro) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "basic-info box"
  }, [_c('span', [_vm._v(" 主页 ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.profile.home_page ? _vm.profile.home_page : '--') + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "basic-info box"
  }, [_c('span', [_vm._v(" QQ ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.profile.qq ? _vm.profile.qq : '--') + " ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1903e406","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User.vue
// module id = 236
// module chunks = 1